import { createSlice } from "@reduxjs/toolkit";

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    sidebarShow: true,
    sidebarUnfoldable: false,
  },
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarShow = !state.sidebarShow;
    },
    setSidebarShow: (state, action) => {
      state.sidebarShow = action.payload;
    },
    toggleSidebarUnfoldable: (state) => {
      state.sidebarUnfoldable = !state.sidebarUnfoldable;
    },
  },
});

export const { toggleSidebar, setSidebarShow, toggleSidebarUnfoldable } = sidebarSlice.actions;

export default sidebarSlice.reducer;
